import { api } from './client.js';

/** 서버: modules/admins (xadmin_account 테이블, admin_login 과 별개). */
export interface AdminAccount {
  id: number;
  userid: string;
  authname: string | null;
  /** 직책. 권한과 무관한 순수 표시 값 - 이름 옆에 같이 보여준다. */
  position: string | null;
  /** 등급 여러 개 가능 (서버가 쉼표로 저장한 authtype 을 배열로 풀어 내려준다). */
  authtypes: string[];
  isActive: boolean;
  createdBy: string | null;
  createdAt: string;
}

export interface CreateAdminAccountInput {
  userid: string;
  password: string;
  authname: string;
  position: string;
  authtypes: string[];
}

/** 필드를 안 보내면 그대로 둔다 - userid 는 수정 대상에서 뺐다(auth.service.ts 참고). */
export interface UpdateAdminAccountInput {
  authname?: string;
  position?: string;
  authtypes?: string[];
  isActive?: boolean;
  password?: string;
}

export const adminsApi = {
  list: () => api.get<{ accounts: AdminAccount[] }>('/admins'),
  create: (input: CreateAdminAccountInput) => api.post<{ account: AdminAccount }>('/admins', input),
  update: (id: number, input: UpdateAdminAccountInput) =>
    api.patch<{ account: AdminAccount }>(`/admins/${id}`, input),
};
